import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import moment from 'moment';
import { makeStyles } from '@mui/styles';

import { DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	}
}));

const RETFilesHistoryDataTable = (props) => {
	const { className, data, ...rest } = props;
	const classes = useStyles();

	const _getTableColumns = () => (
		[
			{
				name: 'fileName',
				label: 'File Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'userID',
				label: 'User Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'timeStamp',
				label: 'Import Date',
				options: {
					display: true,
					filterType: 'textField',
					customBodyRender: (value, tableMeta, updateValue) => <>{moment(value).format('DD-MM-YYYY HH:mm:ss').toString()}</>
				}
			}
		]
	);
	const _getTableOptions = () => ({
		filter: false,
		selectableRows: false,
		expandableRows: false, // Try Adding This
		search: false,
		viewColumns: false
	});
	return (
		<div {...rest} className={clsx(classes.container, className)}>
			<DataTable
				id="dumpsDataTable"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
				options={_getTableOptions()}
			/>
		</div>
	);
};

RETFilesHistoryDataTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default RETFilesHistoryDataTable;
